import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=0c57eccc&scoped=true&"
import script from "./youtube.vue?vue&type=script&lang=ts&"
export * from "./youtube.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57eccc",
  null
  
)

export default component.exports